var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer-component"},[_c('div',{staticClass:"footer-content"},[_c('p',[_vm._v("Copyright © 2026 杭州谱地新能源科技有限公司. All rights reserved. 浙ICP备2021005693号")])])])
}]

export { render, staticRenderFns }